// extracted by mini-css-extract-plugin
module.exports = {"card":"MemberCard_card__1c1g1"};